<header
  *ngIf="{
    isHandset: isHandset$ | async,
    currentUser: currentUser$ | async,
    avatarUrl: avatarUrl(),
    isLoggingOut: isLoggingOut$ | async,
    tasksCount: tasksCount$ | async,
    isLoadingSupersetOAuthData: isLoadingSupersetOAuthData()
  } as STATE"
  elementBounding
  listenFor="all"
  cssVarName="toolbar"
  class="toolbar"
>
  <section class="toolbar__actions">
    <button
      (click)="navigateToSuperset()"
      type="button"
      button
      variant="primaryLight"
      [loading]="!!STATE.isLoadingSupersetOAuthData"
      loadingText="Redirection en cours..."
      size="md"
    >
      <mat-icon
        [svgIcon]="'dgi-market-analysis-stroke-rounded'"
        color="primary"
      ></mat-icon>
      Accès à la BI
    </button>
    <button
      (click)="navigateToPortal()"
      type="button"
      button
      variant="secondaryOutline"
      size="md"
    >
      <mat-icon [svgIcon]="'dgi-msg'"></mat-icon>
      Aller à la messagerie
    </button>

    <!--
    <button
      type="button"
      class="toolbar__actions toolbar__actions--task"
      routerLink="/import-task"
    >
      <mat-icon [svgIcon]="'dgi-orbit'" color="secondary"></mat-icon>
      Tâches en cours
      <span>{{ STATE.tasksCount || 0 }}</span>
    </button> -->
  </section>

  <section *ngIf="!STATE.isHandset && STATE.currentUser" class="toolbar__user">
    <!-- <span class="toolbar__bell-icon">
      <img [lazyLoad]="'/assets/icons/bell-pin.svg'" alt="" />
    </span> -->

    <div [matMenuTriggerFor]="menu">
      <span class="toolbar__user__icon"
        ><img [lazyLoad]="'/assets/icons/admin.svg'" alt=""
      /></span>
    </div>

    <mat-menu #menu="matMenu">
      <section class="profile">
        <article class="profile__container">
          <div class="profile__container-avatar">
            <img
              [lazyLoad]="STATE.avatarUrl"
              [width]="42"
              [height]="42"
              [alt]="
                STATE.currentUser.firstName + ' ' + STATE.currentUser.lastName
              "
            />
          </div>
          <div class="profile__container-infos">
            <h3 class="profile__container-infos__name">
              {{ STATE.currentUser.firstName }}
              {{ STATE.currentUser.lastName }}
            </h3>
            <p *ngIf="!roleVisible" class="profile__container-infos__role">
              {{ STATE.currentUser.role.name }}
            </p>
          </div>
        </article>
      </section>
      <div class="divider"></div>
      <a routerLink="{{ routes.accountSetting }}" mat-menu-item>
        <mat-icon svgIcon="dgi-settings"></mat-icon>
        Paramètres du compte
      </a>

      <a routerLink="{{ routes.accountSecurity }}" mat-menu-item>
        <mat-icon svgIcon="dgi-square-lock-01"></mat-icon>
        Paramètres de sécurité
      </a>

      <button
        (click)="logout()"
        [disabled]="STATE.isLoggingOut"
        class="danger-item"
        mat-menu-item
      >
        <mat-icon svgIcon="dgi-logout-02"></mat-icon>
        Se déconnecter
      </button>
    </mat-menu>
  </section>
</header>
